module.exports = __webpack_public_path__ + "static/img/id_card_3.c443e4f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/id_card_3.png
// module id = aJBf
// module chunks = 1